(() => {
  const openLinkedDetails = (hash) => {
    const target = document.getElementById(hash.slice(1));
    const disclosure = target?.matches('.vianne-detail-disclosure') ? target : target?.querySelector('.vianne-detail-disclosure');
    if (disclosure instanceof HTMLDetailsElement) disclosure.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (link?.hash && link.origin === location.origin && link.pathname === location.pathname) openLinkedDetails(link.hash);
  });
  const openCurrentDetails = () => { if (location.hash) openLinkedDetails(location.hash); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openCurrentDetails, { once: true });
  else openCurrentDetails();
  window.addEventListener('hashchange', openCurrentDetails);
  const selectedDisclosures = new WeakMap();
  document.addEventListener('shopify:block:select', (event) => {
    const disclosure = event.target.closest('.vianne-detail-disclosure');
    if (disclosure) {
      selectedDisclosures.set(disclosure, disclosure.open);
      disclosure.open = true;
    }
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const disclosure = event.target.closest('.vianne-detail-disclosure');
    if (disclosure && selectedDisclosures.has(disclosure)) {
      disclosure.open = selectedDisclosures.get(disclosure);
      selectedDisclosures.delete(disclosure);
    }
  });
  const mobileProductGallery = window.matchMedia('(max-width: 768px)');
  const productGalleryControllers = new WeakMap();
  const productGallerySelector = '[data-cm-product-layout][data-cm-media-ratio="auto"]';
  const productGallerySections = (scope) => {
    const sections = [];
    if (scope instanceof Element && scope.matches(productGallerySelector)) sections.push(scope);
    scope.querySelectorAll?.(productGallerySelector).forEach((section) => sections.push(section));
    return sections;
  };
  const createProductGalleryController = (section) => {
    const carousel = section.querySelector('sht-carousel[id^="productGalleryCarousel-"]');
    const track = carousel?.querySelector('.js-product-slideshow');
    const slides = track ? [...track.children].filter((child) => child.classList.contains('js-product-slideshow-item')) : [];
    if (!carousel || !track || !slides.length) return null;
    let frame = 0;
    const imageListeners = [];
    const currentSlide = () => {
      const viewportCenter = track.scrollLeft + track.clientWidth / 2;
      return slides.reduce((closest, slide) => {
        const closestDistance = Math.abs(closest.offsetLeft + closest.offsetWidth / 2 - viewportCenter);
        const slideDistance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - viewportCenter);
        return slideDistance < closestDistance ? slide : closest;
      }, slides[0]);
    };
    const resize = (slide) => {
      if (!mobileProductGallery.matches || section.dataset.cmMediaRatio !== 'auto') {
        track.style.removeProperty('height');
        return;
      }
      const selected = slide?.classList.contains('js-product-slideshow-item') ? slide : currentSlide();
      const media = selected?.querySelector('sht-prd-slideshow-itm');
      const height = Math.ceil(media?.getBoundingClientRect().height || 0);
      if (height > 0 && track.style.height !== `${height}px`) track.style.height = `${height}px`;
    };
    const requestResize = (slide) => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => resize(slide));
    };
    const onItemChanged = (event) => requestResize(event.detail?.currentElement);
    const onScroll = () => requestResize();
    carousel.addEventListener('itemChanged', onItemChanged);
    track.addEventListener('scroll', onScroll, { passive: true });
    slides.forEach((slide) => slide.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      const onLoad = () => requestResize();
      image.addEventListener('load', onLoad, { once: true });
      imageListeners.push([image, onLoad]);
    }));
    requestResize();
    return {
      requestResize,
      destroy() {
        window.cancelAnimationFrame(frame);
        carousel.removeEventListener('itemChanged', onItemChanged);
        track.removeEventListener('scroll', onScroll);
        imageListeners.forEach(([image, onLoad]) => image.removeEventListener('load', onLoad));
        track.style.removeProperty('height');
      },
    };
  };
  const initializeProductGalleries = (scope = document) => {
    productGallerySections(scope).forEach((section) => {
      if (productGalleryControllers.has(section)) return;
      const controller = createProductGalleryController(section);
      if (controller) productGalleryControllers.set(section, controller);
    });
  };
  const resizeProductGalleries = () => {
    initializeProductGalleries();
    productGallerySections(document).forEach((section) => productGalleryControllers.get(section)?.requestResize());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeProductGalleries(), { once: true });
  else initializeProductGalleries();
  document.addEventListener('shopify:section:load', (event) => initializeProductGalleries(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    productGallerySections(event.target).forEach((section) => {
      productGalleryControllers.get(section)?.destroy();
      productGalleryControllers.delete(section);
    });
  });
  window.addEventListener('resize', resizeProductGalleries, { passive: true });
  mobileProductGallery.addEventListener('change', resizeProductGalleries);
})();
